import { initializeApp } from "firebase/app";
import { getFirestore, collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize App Check BEFORE Firestore
if (typeof window !== "undefined" && process.env.REACT_APP_RECAPTCHA_SITE_KEY) {
  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(process.env.REACT_APP_RECAPTCHA_SITE_KEY),
    isTokenAutoRefreshEnabled: true,
  });
}

// Initialize Firestore
const db = getFirestore(app);

export const saveEmail = async (email) => {
  try {
    await addDoc(collection(db, 'waitlist'), {
      email: email,
      createdAt: serverTimestamp()
    });
    return true;
  } catch (error) {
    return false;
  }
};

export const savePitchDeckRequest = async (formData) => {
    try {
      const pitchDeckData = {
        ...formData,
        createdAt: serverTimestamp(),
        status: 'pending', // pending, sent, or rejected
        source: formData.source || 'direct'
      };
      const docRef = await addDoc(collection(db, 'pitchDeckRequests'), pitchDeckData);
      return { success: true, id: docRef.id };
    } catch (error) {
      return { success: false, error: error.message };
    }
  };

export default db;